var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found-page fill-space"},[_c('p',{staticClass:"lead text-center center-center"},[_c('router-link',{attrs:{"to":_vm.sessionUserHomePage}},[_vm._v("Page Not Found"),_c('br'),_vm._v("Return to Dashboard")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }